import { Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

export function LinksCard({ code }) {
  const base = window.location.origin;
  const links = [
    ["lojista", "Cadastro de lojistas", `${base}/boy/${code}/lojista`, "Envie para as lojas que vão pedir entregas. Depois do cadastro elas já podem pedir."],
    ["motoboy", "Cadastro de motoboys", `${base}/boy/${code}/motoboy`, "O motoboy se cadastra e fica aguardando sua aprovação."],
    ["portal", "Área do lojista (pedir entrega)", `${base}/boy/${code}`, "Onde o lojista entra com CPF/CNPJ para pedir e acompanhar as corridas."],
  ];
  const copy = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copiado");
    } catch {
      toast.error("Copie o link manualmente");
    }
  };
  return (
    <section className="card-surface space-y-4 p-5" data-testid="boy-links-card">
      <div className="flex items-center justify-between gap-2"><p className="eyebrow">Links da empresa</p><span className="rounded bg-muted px-2 py-0.5 font-mono text-xs" data-testid="boy-company-code">Código {code}</span></div>
      {links.map(([k, title, url, hint]) => (
        <div key={k} className="flex flex-col gap-2 rounded-lg border p-3 sm:flex-row sm:items-center">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold">{title}</p>
            <p className="truncate font-mono text-xs text-primary" data-testid={`boy-link-${k}`}>{url}</p>
            <p className="text-xs text-muted-foreground">{hint}</p>
          </div>
          <div className="flex shrink-0 gap-2">
            <Button size="sm" variant="outline" onClick={() => copy(url)} data-testid={`boy-link-copy-${k}`}><Copy className="mr-1.5 h-4 w-4" />Copiar</Button>
            <Button size="sm" variant="ghost" asChild><a href={url} target="_blank" rel="noreferrer" title="Abrir" data-testid={`boy-link-open-${k}`}><ExternalLink className="h-4 w-4" /></a></Button>
          </div>
        </div>
      ))}
    </section>
  );
}
